import React, { useState } from 'react';
import { BlockIssueForm } from './BlockIssueForm';

export function BlockActions({ reportId, block }) {
    const [showIssueForm, setShowIssueForm] = useState(false);

    return (
        <>
            <div className="block-actions">
                <span className="block-actions__ask-agent-wrapper">
                    <button
                        className="block-actions__ask-agent"
                        disabled
                    >
                        <i className="fa fa-robot"></i>
                    </button>
                    <span className="block-actions__ask-agent-tooltip">
                        Pronto vas a poder dialogar con Dashbito sobre esta informacion
                    </span>
                </span>
                <button
                    className="block-actions__report-issue"
                    onClick={() => setShowIssueForm(!showIssueForm)}
                    title="Reportar un problema con este bloque"
                >
                    <i className="fa fa-flag"></i>
                </button>
            </div>
            {showIssueForm && (
                <BlockIssueForm
                    reportId={reportId}
                    block={block}
                    onClose={() => setShowIssueForm(false)}
                />
            )}
        </>
    );
}
